import config from 'config';

export const isEmpMembership = ({ membership }) => {
  const membershipTypeId = config.get('public.membershipTypeIds');
  return [membershipTypeId.emp, membershipTypeId.anniversaryEmp].includes(
    membership?.membershipTypeId
  );
};
